import React from 'react';
import { Navigate, Outlet } from 'react-router';
import LoadingPage from 'auth/LoadingPage';
import { isBlockedPlan } from 'components/Pricing/plans';
import useSession, {
  isAccountCreated,
  isAccountSessionLoaded,
} from 'hooks/useSession';
import useSubscriptionDetails from 'hooks/useSubscriptionDetails';
import { PLAN_PATH } from 'routes';
import { PlanType } from 'utils/plans';

interface LegacyPlanRedirectRoutesProps {
  isLoading: boolean;
  planType?: PlanType;
}

export const LegacyPlanRedirectRoutes: React.FC<
  LegacyPlanRedirectRoutesProps
> = ({ isLoading, planType }) => {
  if (isLoading) {
    return <LoadingPage />;
  }

  if (isBlockedPlan(planType)) {
    return <Navigate to={PLAN_PATH} replace />;
  }

  return <Outlet />;
};

const ConnectedLegacyPlanRedirectRoutes = () => {
  const accountCreated = useSession(isAccountCreated);
  const accountSessionLoaded = useSession(isAccountSessionLoaded);
  const { data, isError, isFetching, isLoading } = useSubscriptionDetails({
    enabled: accountSessionLoaded && accountCreated,
  });
  const planType =
    accountSessionLoaded && accountCreated && !isError
      ? data?.subscriptionDetails.planType
      : undefined;
  const isRefreshingBlockedPlan = isFetching && isBlockedPlan(planType);

  return (
    <LegacyPlanRedirectRoutes
      isLoading={!accountSessionLoaded || isLoading || isRefreshingBlockedPlan}
      planType={planType}
    />
  );
};

export default ConnectedLegacyPlanRedirectRoutes;
